import { ImageViewer } from "./ImageViewer";
import { Image } from "../types/images";

interface DesktopImageViewerProps {
  images: Image[];
  isOpen: boolean;
  onClose: () => void;
  slideIndex?: number;
}

export const DesktopImageViewer = ({
  images,
  isOpen,
  onClose,
  slideIndex,
}: DesktopImageViewerProps) => {
  return (
    <ImageViewer
      images={images}
      isOpen={isOpen}
      onClose={onClose}
      carouselId="desktopImageViewer"
      slideIndex={slideIndex}
    />
  );
};
